/**
 * Canonical TanStack Query keys.
 * Values match existing legacy keys so current invalidateQueries keep working.
 */
export const queryKeys = {
  agents: {
    all: ['get-all-agents'],
    feeda: ['get-feeda-agents'],
    detail: id => (id ? ['get-single-agent', id] : ['get-single-agent']),
  },
  models: {
    all: ['get-all-models'],
  },
  tools: {
    all: toolType => ['list', toolType || 'user_created'],
    admin: ['admin_list'],
  },
  skills: {
    all: ['skills-list'],
    detail: id => (id ? ['skill-detail', id] : ['skill-detail']),
  },
  teams: {
    all: ['teams'],
    admin: searchQuery => ['admin_teams', searchQuery],
  },
  workflows: {
    all: ['get_all_workflows'],
    detail: id => (id ? ['get-workflow-details', id] : ['get-workflow-details']),
  },
  projects: {
    all: ['get_all_projects'],
  },
  sessions: {
    root: ['sessions'],
    sidebar: payload => ['sessions', 'sidebar_sessions', payload],
  },
  cronJobs: {
    all: ['cron-jobs'],
  },
};

/** Prefix used to invalidate all session queries (sidebar + related). */
export const sessionsInvalidateKey = queryKeys.sessions.root;
